module.exports = __webpack_public_path__ + "static/img/图层1.fec45ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层1.png
// module id = V0CO
// module chunks = 0